(ns app.front.view.admin.commands.fix-assessment-reports
  (:require [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.entity-table :as entable]
            [app.front.view.group.admin.common :as acommon]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [core.front.comm :as comm]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [re-frame.std-interceptors :as interceptors]
            [reagent.core :as r]))

(rf/reg-event-fx ::get-candidates
  (fn [{:keys [db]} _]
    {:db           (assoc-in db [::state :loading?] true)
     :comm/command {:command    :admin/get-assessment-unstuck-candidates
                    :method     :get
                    :on-success [::get-candidates.success]}}))

(rf/reg-event-db ::get-candidates.success
  (interceptors/path ::state)
  (fn [state [_ _ {:keys [help-txt candidates]}]]
    (-> state
        (assoc :candidates candidates
               :loading? false
               :help-txt help-txt
               :groups (set/union (->> candidates
                                       (map (fn [{:keys [group-id uses-permit-upload?]}]
                                              [group-id uses-permit-upload?]))
                                       set)
                                  (or (:groups state) #{}))))))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::loading?
  :<- [::state]
  :-> :loading?)

(rf/reg-sub ::groups
  :<- [::state]
  :-> :groups)

(rf/reg-sub ::help-txt
  :<- [::state]
  :-> :help-txt)

(rf/reg-sub ::candidates
  :<- [::state]
  (fn [state [_ group-id]]
    (-> (->> state
             :candidates
             (group-by :group-id))
        (get group-id))))

(rf/reg-event-fx ::re-process-reports
  (fn [{:keys [db]} [_ report-ids]]
    (if (->> db
             ::state
             :candidates
             (map :report-id)
             set
             (set/difference (set report-ids))
             empty?)  ;; check that all ids are in db
      {:db           (assoc-in db [::state :loading?] true)
       :comm/command {:command :admin/re-process-assessment-reports
                      :method  :post
                      :data    (util/mmap report-ids)
                      :notify  {:success (str "Processed " (count report-ids) " reports")}
                      :on-done [::re-process-reports.done]}}
      {:db       (assoc-in db [::state :loading] true)
       :dispatch [:notifications/add
                  :toast
                  :error
                  "Invalid state on tool"
                  "Unexpected report id, please refresh page"]})))

(rf/reg-event-fx ::re-process-reports.done
  (interceptors/path ::state)
  (fn [_ [_ status body req-id]]
    {:fx [[:dispatch [::get-candidates]]
          (when (not= 200 status)
            [:dispatch (comm/error-notification-evt status body req-id)])]}))

(defn view [match]
  (r/with-let [*selected (r/atom #{})]
    [acommon/admin-page-v2
     (util/mmap {:title "Fix assessment reports"}
                match)
     [:div
      [:section
       [ui/help (<sub [::help-txt])]
       (if (<sub [::loading?])
         (cc/button-skeleton)
         [ui/button {:on-click #(>evt [::get-candidates])}
          "Get candidates"])]
      [:section
       [:ul.mb-8
        (for-frag [[group-id uses-upload?] (<sub [::groups])]
          [:li
           [:div.flex.gap-4.items-center
            [:div.flex.flex-col.gap-2.w-full
             [:a {:href (href/href :view/group.reporting.assessment (util/mmap group-id))}
              "Go to reports for group " group-id]
             (when uses-upload? "📜️ This group uses permit package submissions!")]
            [ui/button {:on-click #(reset! *selected (->> (<sub [::candidates group-id]) (map :report-id) set))
                        :kind     :secondary}
             "Select this group"]]
           [:ul.gap-y-4.mt-4
            (for-frag [{:keys [report-id workspace-id message-id ts has-resp? is-error?]} (<sub [::candidates group-id])]
              [:li
               [:div.flex.items-center.gap-4
                [:div
                 (cc/checkbox
                   {:id         (str report-id)
                    :checked    (contains? @*selected report-id)
                    :label-text workspace-id
                    :on-change  #(swap! *selected
                                        (fn [s]
                                          ((if (contains? s report-id) disj conj) s report-id)))})]
                (if message-id
                  [:a.flex.gap-2
                   {:href (href/href :view/admin.entity-lookup-with-param
                                     {:search-term (str "[:message/target-entity " report-id "]")})}
                   (cc/icon {:description "" :icon i/check}) "Sent to remote"]
                  [:div "Unkown if sent"])
                (if has-resp?
                  [:div.flex.gap-2 {:class (when is-error? "text-ui-red")}
                   (cc/icon {:description "" :icon (if is-error? i/remove i/check)})
                   "Processed by remote"]
                  [:div "Unkown status on remote"])
                [:div.ml-16.flex.gap-2.items-center "Started:" [entable/format-instant ts]]]])]])]
       (if (<sub [::loading?])
         (cc/button-skeleton)
         [ui/button
          {:on-click #(do
                        (>evt [::re-process-reports (vec @*selected)])
                        (reset! *selected #{}))
           :disabled (empty? @*selected)}
          (str "Re-process selected " (count @*selected) " reports")])]]]))

(def route
  {:name        :view/admin.commands.fix-assessment-reports
   :own-layout? true
   :view        view})
